<template>
  <div>
    <div class="active-items">
      <div class="active-items-title-read">
        <div class="active-item-read flex-between">
          <div class="active-item-label" v-if="row.cate_list" :style="row.cate_list.length > 0 && row.cate_list[0].name == '视频'
          ? 'background: linear-gradient(96deg, #0091FF 0%, #F4FAFF 100%);' : ''">
            <span v-for="(cate,i) in row.cate_list" :key="i">{{ cate.name }} &nbsp;</span>
          </div>
          <div class="active-item-read-num">{{ row.views_count }}阅读</div>
        </div>
        <div class="active-item-title flex-start">
          <img src="../../assets/images/other/icon-yinhao-1.png" alt="">
          <div class="active-item-title-text">{{ row.title }}</div>
          <img src="../../assets/images/other/icon-yinhao-2.png" alt="">
        </div>
      </div>

      <div class="active-item-pics">
        <div class="active-item-li" v-for="item in row.pics_url" :key="item">
          <img :src="item" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* 单图 */
.active-item-pics {
  padding: 0 .2rem .2rem;
  display: flex;
  flex-wrap: wrap;
}
.active-item-li {
  width: 49%;
  margin-bottom: .2rem;
}
.active-item-li:nth-child(odd) {
  margin-right: 2%;
}
.active-item-li img{
  border-radius: .1rem;
  width: 100%;
}
.active-items {
  /*width: 6.7rem;*/
  background: #fff;
  border-radius: .2rem;
  /*padding: 10px;*/
  margin: 10px;
}

.active-items-title-read {
  padding-bottom: .2rem;
}

.active-item-title {
  margin-top: .2rem;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  padding: 0 .2rem;
}

.active-item-title-text {
  margin: 0 3px;
}

.active-item-title img {
  display: inline-block;
  width: 9px;
  min-width: 9px;
}

.active-item-read {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  padding-top: 0.2rem;
  width: 100%;
}

.active-item-read-num {
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #969799;
  padding:0 .2rem;
}

.active-item-label {
  background: linear-gradient(270deg, #F8D77F 0%, #FCAB15 100%);
  border-radius: 0px 50px 50px 0px;
  color: #fff;
  font-size: 10px;
  padding: 3px 5px;
}

</style>

<script>
export default {
  name: "NewsItem2",
  components: {},
  props: {
    row: {
      type: Object,
      default: {
        title: '',
        cate_list: []
      }
    }

  },

  data: function () {
    return {}
  },

  methods: {},

  filters: {}

};
</script>




// WEBPACK FOOTER //
// NewsItem4.vue?59ffae16